// extracted by mini-css-extract-plugin
export default {"container":"MyToast_container__e1m8V","toast":"MyToast_toast__bQU5N"};